import { render, staticRenderFns } from "./SingleLayerMainInfos.vue?vue&type=template&id=6c4b6432&scoped=true"
import script from "./SingleLayerMainInfos.vue?vue&type=script&lang=ts"
export * from "./SingleLayerMainInfos.vue?vue&type=script&lang=ts"
import style0 from "./SingleLayerMainInfos.vue?vue&type=style&index=0&id=6c4b6432&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4b6432",
  null
  
)

export default component.exports